/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Tow_Receipts_HintInputs */

const en_case_doc_tow_receipts_hint = /** @type {(inputs: Case_Doc_Tow_Receipts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lost income?`)
};

const pt_br2_case_doc_tow_receipts_hint = /** @type {(inputs: Case_Doc_Tow_Receipts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lucros cessantes?`)
};

/**
* | output |
* | --- |
* | "Lost income?" |
*
* @param {Case_Doc_Tow_Receipts_HintInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_tow_receipts_hint = /** @type {((inputs?: Case_Doc_Tow_Receipts_HintInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Tow_Receipts_HintInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_tow_receipts_hint(inputs)
	return pt_br2_case_doc_tow_receipts_hint(inputs)
});